import { StringsType } from "./en"

export const it: StringsType = {
  bubbleExpiration: {
    expiredTitle: "Premium gratuito è scaduto",
    expiredSubtitle: "Passa a Premium per la migliore esperienza PhotoVault",
    expiredSubtitlePremium:
      "Passa a Premium per un'ottima esperienza PhotoVault",
    expiredSubtitleUltimate:
      "Passa a Ultimate per la migliore esperienza PhotoVault",
    trashRecovery: "Recupero cestino",
    cloudVault: "Cloud Vault",
    spaceSaver: "Space Saver",
    noAds: "Nessuna pubblicità",
    everyPremiumFeature: "Ottieni tutte le\nfunzionalità Premium",
    everyUltimateFeature: "Ottieni tutte le\n funzionalità Ultimate",
    unlockUltimateTools: "Sblocca tutti gli strumenti per la privacy nell'app.",
    cloudVaultUltimate: "Cloud Vault - 1.000 GB",
    organizationPlus: "Organizzazione+",
    organizationPlusDesc: "Crea sotto-album, trova duplicati e altro ancora.",
    perMonth: "al mese",
    perYear: "all'anno",
    justOnce: "solo una volta",
    lifetime: "A vita",
    threeMonths: "3 Mesi",
    lifetimeTitle: "Piano a vita",
    lifetimeDescription:
      "Il piano a vita sarà disponibile presto. Resta sintonizzato per gli aggiornamenti!",
    lifetimeFeature1: "Pagamento unico",
    lifetimeFeature2: "Accesso a vita a tutte le funzionalità",
    lifetimeFeature3: "Miglior valore per utenti a lungo termine",
    lifetimeCta: "Acquista Lifetime",
    lifetimeSheetDisclaimer: "Backup cloud (50GB) incluso per 5 anni.",
    lifetimeSheetDisclaimerDetailed:
      "5 anni di backup Cloud Vault (50 GB) sono inclusi con il tuo piano a vita. Dopo, sarai idoneo per un abbonamento Cloud Vault scontato disponibile solo per i membri a vita. Tutte le funzionalità Premium rimarranno sempre disponibili senza costi aggiuntivi.",
    lifetimeDisclaimerCloudStorage:
      "5 anni di backup Cloud Vault (50 GB) sono inclusi con il tuo piano a vita.",
    lifetimeDisclaimerAfterPeriod:
      "Dopo 5 anni, sarai idoneo per un abbonamento Cloud Vault scontato disponibile solo per i membri a vita.",
    lifetimeDisclaimerPremiumFeatures:
      "Tutte le funzionalità Premium rimarranno sempre disponibili senza costi aggiuntivi.",
    monthly: "Mensile",
    yearly: "Annuale",
    selectPlan: "Seleziona un piano per continuare",
    unlockPrivacyTools: "Sblocca eccellenti strumenti per la privacy.",
    cloudVaultGB: "Cloud Vault - 50 GB",
    secureBackups: "Backup sicuri che rimangono criptati.",
    freeUpSpace: "Libera spazio sul tuo telefono.",
    recoverDeleted: "Recupera elementi eliminati dal cestino.",
    fullExperience: "L'esperienza completa senza interruzioni.",
    restorePurchases: "Ripristina acquisti",
    basicTitle: "Private Photo Vault Basic",
    free: "GRATUITO",
    basicDescription:
      "Basic è la versione gratuita di PhotoVault. Protegge ancora le tue foto importanti dietro uno schermo PIN e ti offre buone funzionalità di privacy.",
    switchToBasic: "Passa a Basic",
    termsOfService: "Termini di servizio",
    privacy: "Privacy",
    switchToPremium: "Passa a Premium",
    switchToUltimate: "Passa a Ultimate",
  },
  title: "Accesso Illimitato a Tutte le Funzionalità",
  freeTrial: "Prova Gratuita",
  startPlan: "Inizia l'Abbonamento",
  pricePerMonth: (price: any) => `${price}/mese`,
  pricePerYear: (price: any) => `${price} per anno`,
  discount: (discount: number) => `${discount}% DI SCONTO`,
  new: "nuovo",
  trashRecovery: "Recupera il Cestino",
  adFree: "Esperienza Senza Pubblicità",
  breakIn: "Rapporto Irruzione: Foto e GPS",
  wireless: "Trasferimento foto via wireless",
  decoy: "Codice di accesso Decoy",
  pattern: "Sequenza di blocco",
  appDisguise: "Travestimento App",
  comingSoon: "presto in arrivo",
  subscriptionTerms: "Condizioni di Sottoscrizione:",
  terms:
    "Il pagamento verrà addebitato sull'Account iTunes alla conferma dell'acquisto. La sottoscrizione si rinnoverà automaticamente a meno che il rinnovo automatico non venga disattivato almeno 24 ore prima della fine del periodo di sottoscrizione. È possibile gestire la propria sottoscrizione e disattivare il rinnovo automatico recandoti nelle Impostazioni dell'Account dopo l'acquisto.",
  privacy: "Privacy",
  alreadyPurchased: "Già Acquistato?",
  termsButton: "Termini",
  monthly: "MENSILE",
  yearly: "ANNUALE",
  popular: "IL PIÙ AMATO",
  save: (discount) => `RISPARMIA ${discount}%`,
  anniversaryTitle: (discount) =>
    `Offerta di anniversario - RISPARMIA ${discount}%`,
  blackFridayTitle: (discount) => `Venerdì nero - RISPARMIA ${discount}%`,
  year: "anno",
  years: "anni",
  hour: "ora",
  hours: "ore",
  minute: "minuto",
  minutes: "minuti",
  second: "secondo",
  seconds: "secondi",
  promoSubtitle: (hours) =>
    `Affrettati, questa offerta durerà solo ${hours} ore`,
  offerExpires: "Fino a quando scade l'offerta",
  unlockDeal: "Sblocca l'affare",
  blackFridayPaywallTitle: "Offerta del Black Friday",
  anniversaryPaywallTitle: "La tua offerta per l'anniversario 🎉",
  blackFridayPaywallSubtitle:
    "Non perdere questa offerta unica per il Black Friday! Ottieni grandi risparmi sulla nostra iscrizione annuale.",
  anniversaryPaywallSubtitle: (years: number, discount: number) =>
    `Congratulazioni per ${years} anni con noi! Per festeggiare, ecco uno sconto del ${discount}% su Premium. Grazie per la tua fedeltà!`,
  blackFridayAnnualTitle: "La tua offerta del Black Friday 🎉",
  anniversaryAnnualTitle: "La tua offerta per l'anniversario 🎉",
  oneYear: "1 anno",
  oneMonth: "1 mese",
  lockedIn: "Questo prezzo annuale sarà bloccato PER SEMPRE",
  subtitleFixed: "Affrettati, questa offerta finirà presto!",
  importTitle: "Aggiungi foto al tuo caveau sicuro",
  importSubtitle: "È 100% privato!",
  importInfo:
    "La nostra crittografia a conoscenza zero assicura che i tuoi dati rimangano privati, anche da noi.",
  importCTA: "Seleziona foto",
  totalMonthsPrice: (price: string) => `12 mesi • ${price}`,
  monthlyPrice: (price: string) => `${price} / mese`,
  oneTimeOffer: {
    title: "La tua offerta una tantum",
    subTitle: "Una volta chiusa la tua offerta una tantum, sparirà!",
    claim: "Richiedi la tua offerta una tantum",
  },
  returnOffer: {
    monthly: (price: string) => `basso come ${price}/mese`,
    title: "La Tua Offerta Esclusiva di Ritorno",
    subTitle:
      "Riattiva la tua iscrizione oggi a una tariffa speciale! Disponibile solo per un tempo limitato",
    discountTitle: "Sconto Speciale",
    cta: "Riattiva Ora",
    discountSubTitle: "Offerta a tempo limitato",
  },
  off: "SCONTO",
  special: "SPECIALE",
  yearlyPlan: "Piano Annuale",
  monthlyPlan: "Piano Mensile",
  subscribe: "Sottoscrivi",
  cancelAnytime: "Cancella in qualsiasi momento",
  freeTrialPaywall: {
    title: "Come funziona la tua prova gratuita",
    firstStep: {
      title: "Ora",
      subtitle:
        "Sblocca l'accesso illimitato a Private Photo Vault e non preoccuparti più che qualcuno veda le tue foto private",
    },
    secondStep: {
      title: "Oggi: Inizia la tua prova gratuita",
      subtitle:
        "Sblocca l'accesso completo a PhotoVault. Oggi non ti verrà addebitato nulla.",
    },
    thirdStep: {
      title: "Tra 7 giorni",
      subtitle:
        "Ti verrà addebitato in questo giorno. Annulla in qualsiasi momento prima, senza problemi.",
    },
    whatsIncluded: "Vedi cosa è incluso",
    viewAllPlans: "Vedi tutti i piani",
    startTrial: "Inizia la prova gratuita",
    footerTitle: (yearlyPrice: string, monthlyPrice: string) =>
      `7 giorni GRATIS e poi ${yearlyPrice}/anno\n(${monthlyPrice} al mese)`,
    footerDisclaimer:
      "Annulla in qualsiasi momento prima della fine della prova. Ti verrà addebitato solo dopo 7 giorni",
    featureList: {
      title: "Cos'è Private Photo Vault?",
      infoTitle: "100% Privato e Sicuro",
      infoSubtitle: "Proteggi i tuoi dati e previeni accessi non autorizzati",
      subTitle: "Passa a Premium e ottieni accesso a:",
    },
    comparePlans: {
      monthly: "Mensile",
      yearly: "Annuale",
      ultimateYearly: "Ultimate annuale",
      threeMonths: "3 mesi",
      freeFor: (days: number) => `Gratuito per ${days} giorni`,
      monthlyPrice: (price: string) => `solo ${price}/mese`,
      dailyPrice: (price: string) => `solo ${price}/giorno`,
      cta: "Continua",
    },
  },
  comparePlans: {
    title: "Confronta piani",
    compare: "Confronta",
    freeTitle: "Gratuito",
    basicTitle: "Base",
    premiumTitle: "Premium",
    ultimateTitle: "Ultimate",
    unlockPremium: "Sblocca Premium",
    unlockUltimate: "Sblocca Ultimate",
    choose: "Scegli un piano",
  },
  features: {
    organizationPlus: "Organizzazione+",
    securityPlus: "Sicurezza+",
    duplicateDetection: "Rilevamento duplicati",
    faceDownLock: "Blocco con schermo verso il basso",
    customIcons: "Icone personalizzate",
    encryptedStorage: "Archiviazione foto criptata",
    unlimitedAlbums: "Album illimitati",
    browser: "Browser web sicuro",
    camera: "Fotocamera privata",
    subalbums: {
      title: "Sottoalbum",
      description:
        "Crea più livelli di sottoalbum per organizzare il tuo contenuto in modo efficiente.",
    },
    filteringAndSearching: {
      title: "Filtraggio e ricerca",
      description:
        "Cerca nei tuoi album e applica filtri per trovare tipi di contenuto specifici.",
    },
    alphanumericPasscode: {
      title: "Codice alfanumerico",
      description:
        "Migliora la sicurezza della tua app utilizzando una password alfanumerica.",
    },
    dualLock: {
      title: "Richiede codice + Face ID",
      description:
        "Per maggiore sicurezza, richiedi sia il codice che Face ID ogni volta che accedi all'app.",
    },
    locationBasedLock: {
      title: "Blocco basato sulla posizione",
      description:
        "Consenti lo sblocco dell'app solo nelle posizioni GPS approvate.",
    },
  },
  gotIt: "Capito!",
  promo: {
    premiumSave: (percent: string) => `RISPARMIA ${percent}% SU PREMIUM`,
    monthly: (price: string) => `Solo ${price}/mese`,
    yearly: (price: string) => `${price}/anno`,
    limited: "TEMPO LIMITATO RIMANENTE",
    claimOffer: "Richiedi l'offerta",
    seconds: (count: number) => (count == 1 ? "SECONDO" : "SECONDI"),
    minutes: (count: number) => (count == 1 ? "MINUTO" : "MINUTI"),
    oneTimeOffer: "OFFERTA UNA TANTUM",
    normalFee: "tariffa normale",
    backTo: "torna a",
    yearlyShort: (price: string) => `${price}/anno`,
  },
  premiumToUltimateBlackFriday: {
    title: "SALDI DEL BLACK FRIDAY",
    subTitle: "PASSA A ULTIMATE",
    cloud: {
      title: "1.000 GB di archiviazione cloud",
      description: "Archiviazione cloud sicura per oltre 500.000 foto",
    },
    duplicateDetection: {
      description: "Individua e rimuovi immagini duplicate",
    },
    organizationPlus: {
      description: "Crea sottoalbum, filtra e cerca le tue foto",
    },
    securityPlus: {
      description:
        "Sicurezza avanzata con password alfanumerica, blocco basato sulla posizione e altro",
    },
    timeRemaining: "TEMPO RIMASTO",
    saleBanner: "OFFERTA MEGA A TEMPO LIMITATO",
    saleTitle: "Saldi del Black Friday 🎉",
    monthPrefix: "12 mesi • ",
    perMonthPrice(price: string) {
      return `${price} / mese`
    },
    monthly: "Mensile",
    ultimateLaunch: {
      title: "AGGIORNA A Ultimate",
      saleTitle: "Offerta Lancio Ultimate 🚀",
      bannerTitle: (discount) => `Lancio Ultimate - RISPARMIA ${discount}%`,
    },
  },
  beforeYouGo: {
    title: "Aspetta - Prima di andartene",
    subtitle: "Mantieni le tue foto sicure e private",
    subtitle2: "Ottieni 7 giorni di Premium completamente gratis.",
    cta: "Inizia la tua prova gratuita",
    cancelTitle:
      "Cancella in qualsiasi momento prima che il tuo periodo di prova termini, e non sarai addebitato fino al completamento dei 7 giorni.",
    skipCta: "No, grazie",
  },
  enableTrial: "Non sei ancora sicuro? Attiva la prova gratuita",
  startTrial: "Inizia la prova gratuita",
  trialActivated: (days) => `PROVA DI ${days} GIORNI ATTIVATA`,
  specialOffer: {
    enabledTitle: "Offerta speciale attivata",
    trialTitle: "Richiedi la tua prova gratuita aggiuntiva di 7 giorni",
    expirationTitle: "Il tuo abbonamento sta per scadere!",
    expirationSubtitle: "Rinnova a un prezzo speciale!",
    priceBoxExpiration: {
      title: "Offerta speciale di rinnovo",
      offerName: "Piano annuale",
      ctaTitle: "Richiedi offerta speciale",
    },
    priceBoxTrial: {
      title: "Offerta esclusiva: prova gratuita aggiuntiva di 7 giorni",
      offerName: "Prova aggiuntiva di 7 giorni",
      ctaTitle: "Richiedi prova gratuita",
    },
  },
  premiumToUltimate: {
    titleLine1: "AGGIORNAMENTO A ULTIMATE",
    titleLine2: "OFFERTA UNICA",
    megaSaleBanner: "MEGA OFFERTA A TEMPO LIMITATO",
    upgradeTitle: "Offerta di aggiornamento Ultimate",
    yearlySubtitlePrefix: "12 mesi •",
    monthlyPriceSuffix: "/ mese",
  },
  monthlyToYearly: {
    titleLine1: "Aggiornamento annuale",
    titleLine2: "Offerta unica",
    subtitleWarning:
      "Una volta chiusa questa offerta unica, non sarà più disponibile!",
    specialLabel: "SPECIALE",
    offerTitle: "Richiedi la tua offerta unica",
    offerName: "Piano annuale",
    subscribeButton: "Abbonati",
    cancelAnytime: "Annulla in qualsiasi momento",
    yearlySubtitlePrefix: "12 mesi •",
    monthlyPriceSuffix: "/ mese",
  },
  expiration: {
    warmup: {
      close: "CHIUDI",
      subtitle:
        "Tieni le tue foto AL SICURO e RECUPERABILI se perdi il telefono o te lo rubano",
      features: {
        cloudVault: {
          title: "Cloud Vault",
          subtitle: "Backup crittografato dei tuoi file",
        },
        cloudVaultUltimate: {
          title: "Cloud Vault",
          subtitle: "1.000 GB di archiviazione Cloud Vault",
        },
        reviews: {
          title: "Oltre 500.000 recensioni a 5 stelle",
          subtitle: "Fidato da milioni di persone",
        },
        noAds: {
          title: "Nessuna pubblicità",
          subtitle: "Esperienza senza pubblicità",
        },
        organizationPlus: {
          title: "Organization+",
          subtitle: "Sottoalbum, filtri migliori e altro ancora",
        },
      },
      footer: "& tutte le funzionalità!",
      switchToPremium: "Passa a Premium",
      switchToUltimate: "Passa a Ultimate",
      titlePremium: "Il tuo Premium è scaduto!",
      titleUltimate: "Il tuo Ultimate è scaduto!",
      popular: "POPOLARE",
      perMonth: "al mese",
      perYear: "all'anno",
    },
    titlePremium: "Premium è scaduto",
    titleUltimate: "Ultimate è scaduto",
    subtitlePremium:
      "Rinnova Premium per mantenere tutte le funzionalità o passa a Basic gratuitamente",
    subtitleUltimate:
      "Rinnova Ultimate per mantenere tutte le funzionalità o passa a Basic gratuitamente",
    basicButton: "Passa a Basic",
    basicTitle: "Cos’è Basic?",
    basicDescription:
      "Basic è la versione gratuita dell'app. Puoi ancora proteggere le tue foto e i tuoi video con un PIN. Tuttavia, perderai l’accesso al backup crittografato di Cloud Vault e a tutte le altre funzionalità Premium",
  },
  animated: {
    title: "Scegli il tuo piano",
    yearlyPrice: (price: string) => `Solo ${price} all’anno`,
    subtitle: "Rinnovo automatico. Annulla quando vuoi",
    cta: "Continua",
    trial: "Prova gratuita attivata",
    breakinShort: "Rapporto effrazione",
    unlimitedPhotos: "Foto illimitate",
  },
  choosePlanTitle: "Choose Your Plan",
  multistep: {
    lockTitle: "Blocca le foto private",
    subtitle: {
      line1: "Offriamo",
      line2: "7 giorni gratis",
      line3: "perché tutti possano proteggere le proprie foto",
    },
    subtitleReminder: {
      line1: "Riceverai un promemoria ",
      line2: "2 giorni ",
      line3: "prima della fine della prova.",
    },
    noPaymentNow: "Nessun pagamento ora",
    startFreeWeek: "Inizia la tua settimana GRATIS",
    payTitle: "7 giorni gratis",
    afterPrice: (price: string) => `poi ${price} / mese`,
    afterBilling: (price: string) =>
      `(fatturato ${price} annualmente dopo la prova)`,
    footerTitle: (price) => `Gratis per 7 giorni. Poi ${price}/anno`,
    footerMonthlyTitle: (price) =>
      `Ti verranno addebitati ${price} immediatamente.`,
    headerTitle: "Prova gratuita di 7 giorni",
    anual: "Annuale",
    monthly: "Mensile",
    noTrial: "Nessuna prova gratuita",
    yearlyPrice: (price) => `${price} / Anno`,
  },
  oneTimeOfferTitle: "OFFERTA UNICA",
  unlockPremiumFor: "Sblocca Premium annuale a",
  oneTimeOfferSubtitle: "Questa è un'offerta unica",
  lowestPrice: "IL PREZZO PIÙ BASSO DI SEMPRE",
  summerSale: {
    title: "SALDI ESTIVI",
    tagline: "Il sole vede tutto... tranne quello che c'è nel tuo vault!",
    timeRemaining: "L'offerta scade presto",
    limitedTimeOffer: "Offerta a tempo limitato",
    savePercent: (percent: number) => `Risparmia il ${percent}%`,
    bannerSubtitle: (price: string) => `Ottieni Premium a ${price}`,
    bannerSubtitleUltimate: (price: string) => `Ottieni Ultimate a ${price}`,
    getPremium: "Ottieni la privacy Premium",
    getUltimate: "Ottieni la privacy Ultimate",
    hours: "ore",
    minutes: "minuti",
    seconds: "secondi",
    features: {
      premiumFeature: {
        title: "Ottieni tutte le funzioni Premium",
        description: "Strumenti Premium che proteggono la tua privacy.",
      },
      cloudVault: {
        title: "Cloud Vault - 50 GB",
        description: "Backup sicuri che rimangono crittografati.",
      },
      noAds: {
        title: "Nessuna pubblicità",
        description: "L'esperienza completa senza interruzioni.",
      },
      faceDownLock: {
        title: "Blocco a faccia in giù",
        description: "Blocca l'app istantaneamente capovolgendo il telefono.",
      },
      breakInReports: {
        title: "Rapporti di intrusione",
        description: "Avvisi se qualcuno tenta di accedere al tuo vault.",
      },
    },
    pricing: {
      summerSale: "Saldi estivi",
      monthly: "Mensile",
      perMonth: (price: string) => `${price} / mese`,
      twelveMonths: "12 mesi",
      originalPrice: (price: string) => price,
      discountedPrice: (price: string) => price,
    },
  },
  halloweenSale: {
    title: "HALLOWEEN SALE",
    tagline: "La notte nasconde molte cose…\nspecialmente le tue!",
    buttonTitle: "Halloween Sale",
  },
  emailPromo: {
    title: "Offerta Premium Esclusiva",
    upgradeButton: "Passa a Premium",
    yearlyTitle: "Premium Annuale",
    decoyDescription:
      "Crea un caveau fittizio che si apre con una password esca",
  },
  onboardingUltimateAlternate: {
    title: "Inizia la tua prova gratuita",
    premiumDescription: "Sblocca eccellenti strumenti per la privacy.",
    ultimateDescription: "La migliore esperienza di Photo Vault.",
    includesPremium: "Include Premium",
    trialPricing: (yearlyPrice: string, monthlyPrice: string) =>
      `7 giorni gratis, poi ${yearlyPrice} (${monthlyPrice}/mese)`,
    timeline: {
      today: "Oggi:",
      todayDescription: "inizia la tua prova gratuita",
      day5: "Giorno 5:",
      day5Description: "ricevi promemoria",
      day7: "Giorno 7:",
      day7Description: (yearlyPrice: string) =>
        `ti verrà addebitato ${yearlyPrice}`,
    },
    comparisonTable: {
      header: "Cosa ottieni",
    },
    didYouKnow: {
      label: "Lo sapevi?",
      statNumber: "3X",
      statDescription: "Gli abbonati ottengono 3 volte più tranquillità",
    },
    pricing: {
      yearlyPlanTitle: "Piano annuale",
      yearlyPlanSubtitle: (yearlyPrice: string) => `${yearlyPrice}/anno`,
      yearlyAmount: (monthlyPrice: string) => `${monthlyPrice}/mese`,
      monthlyTitle: "Mensile",
      monthlyAmount: (monthlyPrice: string) => `${monthlyPrice}/mese`,
      popularBadge: "POPOLARE",
    },
    ctaButton: "Inizia prova gratuita",
  },
}
